module.exports = __webpack_public_path__ + "img/book-2.561f19cf.png";